var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "module" }, [
    _c("div", { staticClass: "contactum-modules" }, [
      _c("div", { staticClass: "clearfix" }, [
        _c("div", { staticClass: "pull-right activate-deactivate-all" }, [
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.toggleModule("all", "activate")
                }
              }
            },
            [_vm._v("Activate")]
          ),
          _vm._v(" |\n        "),
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.toggleModule("all", "deactivate")
                }
              }
            },
            [_vm._v("Deactivate")]
          ),
          _vm._v(" All\n    ")
        ]),
        _vm._v(" "),
        _c("h1", { staticClass: "pull-left" }, [_vm._v(" Modules ")])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wp-list-table widefat contactum-modules" },
        _vm._l(_vm.modules.all, function(module, key) {
          return _c("div", { staticClass: "plugin-card" }, [
            _c("div", { staticClass: "plugin-card-top" }, [
              _c("div", { staticClass: "name column-name" }, [
                _c("h3", [
                  _c("span", { staticClass: "plugin-name" }, [
                    _vm._v(_vm._s(module.name))
                  ]),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "plugin-icon",
                    attrs: { src: module.thumbnail, alt: module.name }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "action-links" }, [
                _c("ul", { staticClass: "plugin-action-buttons" }, [
                  _c(
                    "li",
                    [
                      _c("span", {
                        class: [
                          "contactum-toggle-switch",
                          "big",
                          _vm.isActive(key) ? "checked" : ""
                        ],
                        on: {
                          click: function($event) {
                            return _vm.toggleModule(key)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("el-switch", {
                        attrs: {
                          "active-value": "activate",
                          "inactive-value": "deactivate"
                        },
                        on: {
                          change: function($event) {
                            return _vm.toggleModule(key)
                          }
                        },
                        model: {
                          value: module.name,
                          callback: function($$v) {
                            _vm.$set(module, "name", $$v)
                          },
                          expression: "module.name"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "desc column-description" }, [
                _c("p", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(module.description) +
                      "\n                "
                  )
                ])
              ])
            ])
          ])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }